import Big from 'big.js'
import { BasketItem, OnlyCashPaymentOption, PaymentOptions } from '../basket'
import { Balance } from './types'

export const convertOnlyCashPaymentOptionToBalance = (payment: OnlyCashPaymentOption): Balance => ({
  aviosCollect: payment.aviosCollectValue,
  baseLoyalty: payment.baseLoyalty ?? payment.aviosCollectValue,
  aviosSpent: 0,
  cashTotal: new Big(payment.cashTotalValue.amount),
  cashBase: new Big(payment.cashBaseValue.amount),
  grandTotal: payment.grandTotal ? new Big(payment.grandTotal?.amount ?? 0) : undefined,
  cashTaxes: payment.salesTax
    ? new Big(payment.salesTax.amount)
    : new Big(payment.cashTaxValue?.amount ?? 0),
  cashTotalWithoutTaxes: new Big(payment.cashTotalValue?.amount ?? 0),
  isSalesTaxType: !!payment.salesTax,
  surcharges: {
    total: new Big(0),
    surchargesBreakdown: [],
  },
  taxDetails: payment.taxDetails,
})

export const convertAviosOptionToBalance = (
  payment: PaymentOptions['options'][number],
  isSalesTax: boolean
): Balance => ({
  aviosCollect: payment.aviosCollectValue || 0,
  baseLoyalty: 0,
  aviosSpent: payment.aviosValue,
  cashTotal: new Big(payment.cashValue?.amount ?? 0),
  grandTotal: payment.grandTotal ? new Big(payment.grandTotal?.amount ?? 0) : undefined,
  cashBase: new Big(payment.cashBaseValue?.amount ?? 0),
  cashTaxes: new Big(payment.cashTaxValue?.amount ?? 0),
  cashTotalWithoutTaxes: new Big(payment.cashValue?.amount ?? 0),
  isSalesTaxType: isSalesTax,
  surcharges: {
    total: new Big(0),
    surchargesBreakdown: [],
  },
  taxDetails: payment.taxDetails,
})

export const getBalance = (
  paymentOptions: PaymentOptions,
  optionId: PaymentOptions['options'][number]['id']
) => {
  if (paymentOptions.onlyCashPaymentOption) {
    const isCashOnlyOption = paymentOptions.onlyCashPaymentOption.id === optionId
    if (isCashOnlyOption) {
      return convertOnlyCashPaymentOptionToBalance(paymentOptions.onlyCashPaymentOption)
    }
  }

  const isAviosOption = paymentOptions.options.find((o) => o.id === optionId)
  if (isAviosOption) {
    return convertAviosOptionToBalance(isAviosOption, paymentOptions.isSalesTaxType)
  }

  return undefined
}

export const getSurchargesTotal = (item: BasketItem): Big => {
  return item.surcharges.reduce((sAcc, s) => sAcc.plus(s.amount), new Big(0))
}
